export const domain = 'FullCalendarModel'

export const onSetDateRange = `${domain}/onSetDateRange`
export const onUnsetDateRange = `${domain}/onUnsetDateRange`

export const onSetCurrentView = `${domain}/onSetCurrentView`
export const onSetCurrentDate = `${domain}/onSetCurrentDate`


export const DEFAULT_OFFSET = 30